module.exports = __webpack_public_path__ + "img/download.b85e212e.png";